import React, { FC, useState, useCallback, useMemo } from "react"
import Env from "@util/env"
import "./index.scss"

const Plane = ({ color = "#00FFDB" }) => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${Env.getScale()})` }}
    >
      <title>形状结合</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1备份-11"
          transform="translate(-46.000000, -119.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <g id="编组-18" transform="translate(32.000000, 75.000000)">
            <g id="编组-3备份-4">
              <g id="编组-16">
                <g id="飞机" transform="translate(14.000000, 44.000000)">
                  <path
                    d="M13.3886624,0.471385289 C13.4635764,0.399291068 14.4939985,-0.554897146 15.5244206,0.475626125 C16.5944743,1.54578491 15.5244206,2.61594369 15.5244206,2.61594369 L15.5244206,2.61594369 L9.10095587,9.04003929 L6.10291999,12.0383696 L6.42346471,14.9298412 L5.35341103,16 L3.74754485,12.2536585 L5.5067062e-14,10.6460632 L1.07005369,9.5759044 L3.96124132,9.8964806 L6.9592772,6.89815027 L0.535812492,3.68610247 L1.60586618,2.61594369 L9.63676836,4.22353904 Z M11.9308629,7.13386806 L13.3843132,14.3955476 L12.3142595,15.4657063 L9.40893021,9.65604845 L11.9308629,7.13386806 Z"
                    id="形状结合"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
type ISelectorProps = {
  className?: string
  name?: string
  tabs: { key: string; name: string; color?: string }[]
  onClick?: (item: any, active: boolean, idx?: number) => void
  currentIdx?: number
  type?: string
  icon?: boolean
}

const Selector: FC<ISelectorProps> = ({
  className,
  name = "飞线模式",
  type,
  tabs,
  onClick,
  currentIdx,
  icon,
}) => {
  const [current, setCurrent] = useState<number | null>(null)
  const [expand, setExpand] = useState(true)
  useMemo(() => {
    let idx = null
    let exp = false
    if (typeof currentIdx === "number") {
      idx = currentIdx
      exp = true
    }
    setCurrent(idx)
    // setExpand(exp)
  }, [currentIdx, type])
  const click = useCallback(
    (item: any, i: number) => {
      let active = false
      if (current === i) {
        setCurrent(null)
      } else {
        setCurrent(i)
        active = true
      }
      onClick(item, active, i)
    },
    [current, setCurrent]
  )
  const _className = useMemo(() => {
    let cs = ["cm-selector"]
    if (className) {
      cs.push(className)
    }
    if (!expand) {
      cs.push("collapse")
    }
    return cs.join(" ")
  }, [expand, className])
  return (
    <div className={_className}>
      <div
        className="se-title"
        onClick={() => {
          setExpand(!expand)
        }}
      >
        {name}
        <span className="arrow"></span>
      </div>
      <div className="ls-item">
        {tabs.map((item, i) => {
          let act = current === i
          let color = "#00FFDB"
          if (!act) {
            color = "rgba(255,255,255,1)"
          }
          return (
            <div
              className={"it" + (act ? " active" : "")}
              key={i}
              onClick={() => click(item, i)}
            >
              {icon && <Plane color={color} />}
              <span style={{ color }}>{item.name}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Selector
